import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return ["badge"]
  }

  updateBadge() {
    const badge = this.badgeTarget
    const count = this.element.querySelectorAll(`:checked`).length

    if (count > 0) {
      badge.classList.remove("hidden!")
      badge.innerHTML = count
    } else {
      badge.classList.add("hidden!")
    }
  }
}
